<template>
<div>
    <!-- NAVIGATION MENU -->
    <v-navigation-drawer v-model="drawer" overlay-opacity=".8"  app class="grey lighten-2" width="200">
        <div class="d-flex fill-height">
            <div class="primary px-1">
                <div class="mt-1">
                    <v-img 
                        :src="require(`@/assets/maya/_/lupa-blanca.png`)" 
                        max-width="18px" alt="Mayasorting Isotipo"  contain
                        @click="goHome"
                        style="cursor:pointer"></v-img>
                </div>

                <div class="mt-4">
                    <v-img 
                        :src="require(`@/assets/maya/_/ic-instagram.png`)" 
                        max-width="22px" alt="Instagram"  contain
                        @click="goInstagram"
                        style="cursor:pointer"></v-img>
                </div>
                <div>
                    <v-img 
                        :src="require(`@/assets/maya/_/ic-linkedin.png`)" 
                        max-width="22px" alt="Linkedin"  contain
                        @click="goLinkedin"
                        style="cursor:pointer"></v-img>
                </div>
                <div>
                    <v-img 
                        :src="require(`@/assets/maya/_/ic-facebook.png`)" 
                        max-width="22px" alt="Facebook"  contain
                        @click="goFacebook"
                        style="cursor:pointer"></v-img>
                </div>
            </div>

            <div>
                <div class="d-flex justify-center">
                    <div class="pt-4 px-1 pb-4">
                        <v-img 
                            :src="require(`@/assets/maya/_/logo.png`)" 
                            max-width="150px" alt="Maya Sorting"  contain
                            @click="goHome"
                            style="cursor:pointer"></v-img>
                    </div>
                </div>

                <div class="pl-2 mt-4">
                    <v-btn text class="black--text" @click="goSectionHome('inicio')">
                        <span class="subtitle-2" :class="{'text-decoration-underline': $route.path=='/'}">INICIO</span>
                    </v-btn>
                </div>

                <div class="pl-2 mt-1">
                    <v-btn text class="black--text" @click="goSectionHome('nosotros')">
                        <span class="subtitle-2" :class="{'text-decoration-underline': $route.path=='/nosotros'}">NOSOTROS</span>
                    </v-btn>
                </div>

                <div class="pl-2 mt-1">
                    <v-btn text class="black--text" @click="$router.push('/servicios')">
                        <span class="subtitle-2" :class="{'text-decoration-underline': $route.path=='/servicios'}">SERVICIOS</span>
                    </v-btn>
                </div>

                <div class="pl-2 mt-1">
                    <v-btn text class="black--text" @click="goSectionHome('clientes')">
                        <span class="subtitle-2" :class="{'text-decoration-underline': $route.path=='/clientes'}">CLIENTES</span>
                    </v-btn>
                </div>

                <div class="pl-2 mt-1">
                    <v-btn text class="black--text" @click="goSectionHome('contacto')">
                        <span class="subtitle-2" :class="{'text-decoration-underline': $route.path=='/contacto'}">CONTACTO</span>
                    </v-btn>
                </div>

                <div class="pl-2 mt-6">
                    <v-btn text class="black--text" href="https://firebasestorage.googleapis.com/v0/b/msorting-193e2.appspot.com/o/BROCHURE_NVO-TL.pdf?alt=media&token=52fe9cf8-5fa5-4208-a9fb-7afbdcbc9893" target="_blank">
                        <span class="subtitle-2 font-weight-bold">BROCHURE</span>
                    </v-btn>
                </div>
            </div>
        </div>
    </v-navigation-drawer>

    <!-- CONTENT VIEW -->
    <v-main class="primary">
        <!-- <div class="d-flex fill-height justify-center pt-12">
            <div class="pt-4 px-1 pb-4">
                <v-img 
                    :src="require(`@/assets/maya/_/logo_plata.png`)" 
                    max-width="150px" alt="Maya Sorting"  contain
                    @click="goHome"
                    style="cursor:pointer"></v-img>
            </div>
        </div> -->
        <router-view></router-view>
        <Footer />
    </v-main>

    <a href="https://api.whatsapp.com/send?phone=+525541334753&text=Hola%21%20Quisiera%20m%C3%A1s%20informaci%C3%B3n." class="floatSocial" target="_blank">
        <v-icon size="30" color="white" class="my-float">fab fa-whatsapp</v-icon>
    </a>

    <!-- <a href="http://m.me/MSO-654122908553918" title="Hola, quisiera más información" class="floatSocial floatMessenger" target="_blank">
        <v-icon size="30" color="white" class="my-float">fab fa-facebook-messenger</v-icon>
    </a> -->

    <!-- SNACKBAR -->
    <v-snackbar top center v-model="showSnack" :timeout="3000" :color="snack.kind" v-if="snack != null">
        <v-layout>
            <v-icon color="white" small v-if="snack.kind=='success'">fa-check</v-icon>
            <v-icon color="white" small v-if="snack.kind=='error'">fa-exclamation-triangle</v-icon> 
            <v-icon color="white" small v-if="snack.kind=='warning'">fa-exclamation-triangle</v-icon>
            <span class="ml-3">{{ snack.text }}</span>
        </v-layout>
    </v-snackbar>
</div>
</template>

<script>
import Footer from '@/components/Footer'

export default {
    data: () => ({
        drawer: true,
        showSnack: false
    }),
    metaInfo: {
      title: 'MSORTING',
      titleTemplate: '%s | MSORTING'
    },
    computed: {
		snack() {
      		return this.$store.getters.snack;
        },
        statusDrawer() {
            return this.$store.getters.statusDrawer;
        }
    },
    watch: {
        snack(value) {
			if (value) {
				this.showSnack = true;
			} else {
				this.showSnack = false;
			}
        },
        statusDrawer(value) {
            this.drawer = value;
        },
        drawer(value) {
            this.$store.dispatch('setStatusDrawer', value);
        }
    },
    components: {
        Footer
    },
    mounted() {
        setTimeout(() => {
            if (this.$vuetify.breakpoint.smAndDown) {
                this.$store.dispatch('setStatusDrawer', false);
            }
        }, 300);
    },
    methods: {
        goHome() {
            this.$router.push('/');
            if (this.$vuetify.breakpoint.smAndDown) {
                this.$store.dispatch('setStatusDrawer', false);
            }
        },
        goSectionHome(section) {
            this.$store.dispatch('setActual', section);
            if (this.$route.path!='/') {
                this.$router.push('/');
            }
            if (this.$vuetify.breakpoint.smAndDown) {
                this.$store.dispatch('setStatusDrawer', false);
            }
        },
        goInstagram(){
            window.open('https://instagram.com/msorting');
        },
        goFacebook(){
            window.open('https://www.facebook.com/MSO-654122908553918');
        },
        goLinkedin(){
            
        }
    }
}
</script>

<style>
    .v-overlay--active:before {
        opacity: .8 !important;  
    }
    .ober {
        cursor: pointer;
    }
    .not-ober {
        cursor: default;
    }
    [v-cloak] {
		display: none;
	}
	.stk {
		position: sticky;  
		position: -webkit-sticky;
		top:0; 
		z-index:1;
	}
    html {
        scroll-behavior: smooth;
    }

    .floatSocial{
        position:fixed;
        width:60px;
        height:60px;
        bottom:40px;
        right:30px;
        color:#FFF;
        background-color:#25d366;
        border-radius:50px;
        text-align:center;
        font-size:30px;
        box-shadow: 2px 2px 3px #444;
        z-index:100;
        text-decoration: none !important;
    }

    /* .floatWhatsapp-mdAndUp {
        left:170px;
        background-color:#25d366;
    }

    .floatWhatsapp-smAndDown {
        left:16px;
        background-color:#25d366;
    }

    .floatMessenger{
        right:20px;
        background-color:#00C6FF;
    } */

    .my-float{
        margin-top:12px;
        text-decoration: none !important;
    }
</style>

<style  scoped>
    .overlined:hover {
        color: red !important;
    }
</style>
